<template>
  <div>
    <h2 class="sec-title">{{ c.port_title }}</h2>

    <div v-if="loading" class="text-center py-10 text-medium-emphasis">{{ c.loading }}</div>
    <div v-else-if="!items.length" class="empty">{{ c.port_empty }}</div>
    <v-row v-else>
      <v-col v-for="(p, i) in items" :key="i" cols="12" sm="6">
        <v-card variant="flat" class="port-card">
          <v-card-text class="pa-4">
            <div class="d-flex align-center justify-space-between mb-1">
              <div class="num">⇄ {{ p.msisdn || p.destination_msisdn || '—' }}</div>
              <v-chip size="small" :color="statusColor(p)" variant="flat">{{ statusLabel(p) }}</v-chip>
            </div>
            <div class="sub" v-if="p.operator_name || p.port_operator_name">
              {{ (p.operator_name || p.port_operator_name) }} → Veridian
            </div>
            <div class="sub" v-if="p.created_at">{{ c.port_created }} {{ formatDate(p.created_at) }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { cc } from "@/views/client/clientCopy";
import { getToken } from "@/composables/useTokenStorage";
import { getMyPortRequests } from "@/composables/usePortRequestsAPI";

export default defineComponent({
  name: 'PortStatusSection',
  data() { return { loading: true, items: [] }; },
  computed: { c() { return cc(); } },
  async created() { await this.load(); },
  methods: {
    async load() {
      this.loading = true;
      const resp = await getMyPortRequests(getToken());
      this.items = (resp && (resp.port_requests || resp.portRequests)) || (Array.isArray(resp) ? resp : []);
      this.loading = false;
    },
    statusLabel(p) { return p.status_name || p.status || p.port_request_status || '—'; },
    statusColor(p) {
      const s = (this.statusLabel(p) || '').toLowerCase();
      if (s.includes('approved') || s.includes('aprob') || s.includes('complet')) return 'success';
      if (s.includes('reject') || s.includes('resp')) return 'error';
      return 'warning';
    },
    formatDate(d) { return String(d).slice(0, 10); },
  },
});
</script>

<style scoped>
.sec-title { font-size: 1.4rem; font-weight: 800; color: #1a2233; margin-bottom: 16px; }
.port-card { border: 1px solid #E6E9F0; border-radius: 16px; }
.num { font-weight: 800; color: #1a2233; }
.sub { color: #5A6275; font-size: .9rem; }
.empty { text-align: center; color: #5A6275; padding: 40px 0; }
</style>
